import React from 'react'

import LoadingScreen from 'components/common/LoadingScreen/LoadingScreen'

const ResendEmailCollaboratorsPage = ({title, description}) => {

    return (
        <LoadingScreen
            title={title}
            description={description}
            fullpage
        />
    )
}

export default ResendEmailCollaboratorsPage
